import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Services from "../components/Services";
import ScamEducation from "../components/ScamEducation";
import ScamProtection from "../components/ScamProtection";
import About from "../components/About";
import Testimonials from "../components/Testimonials";
import FAQ from "../components/FAQ";
import BookingForm from "../components/BookingForm";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-[#FFFFFF] text-[#0F2E52]">
      <Header />
      <main>
        <Hero />
        <ScamEducation />
        <Services />
        <ScamProtection />
        <About />
        <Testimonials />
        <FAQ />
        <BookingForm />
      </main>
      <Footer />
    </div>
  );
}
